import { MutationObserverOptions, useMutation } from 'react-query';

import { IRepayUmiOutput, RepayUmiInput, queryClient, repayUmi } from 'clients/api';
import { useVaiControllerContract, useUmiTokenContract, useUmiVaultContract } from 'clients/contracts/hooks';
import FunctionKey from 'constants/functionKey';

type Options = MutationObserverOptions<
    IRepayUmiOutput,
  Error,
  Omit<RepayUmiInput, 'umiControllerContract'>
>;

const useRepayUmi = (options?: Options) => {
  const umiControllerContract = useUmiVaultContract();

  return useMutation(
    FunctionKey.REPAY_VAI,
    (params: Omit<RepayUmiInput, 'umiControllerContract'>) =>
      repayUmi({
          umiControllerContract,
        ...params,
      }),
    {
      ...options,
      onSuccess: (...onSuccessParams) => {
        // Invalidate queries related to fetching the user minted VAI amount
        queryClient.invalidateQueries(FunctionKey.GET_MINTED_USERINFO);
        queryClient.invalidateQueries(FunctionKey.GET_V_TOKEN_BALANCES_ALL);

        if (options?.onSuccess) {
          options.onSuccess(...onSuccessParams);
        }
      },
    },
  );
};

export default useRepayUmi;
